export default __webpack_public_path__ + "static/media/open_beta.b4d151ee.svg";